import { Dialog } from '@mui/material';
import { BasicButton } from '@tassat/button';
import React from 'react';

import { ThemesRefreshModalProps } from './types';

export default function ThemeRefreshModal(props: ThemesRefreshModalProps): React.ReactElement<ThemesRefreshModalProps> {
    const {
        classes,
        themeRefreshed
    } = props;

    return (
        <Dialog
            disableEscapeKeyDown
            open={themeRefreshed}
        >
            <div className={classes.content}>
                <h1 className={classes.headerText}>Warning</h1>
                <p>
                    Application version has been updated, please
                    refresh the browser to get the latest version.
                </p>
                <div className={classes.buttons}>
                    <BasicButton
                        onClick={() => window.location.reload()}
                        text='Refresh'
                        type='main'
                    />
                </div>
            </div>
        </Dialog>
    );
}